import { effect, inject, Injectable, signal } from '@angular/core';
import { LogEntry } from './log.model';
import { LogDetailCallsService } from './log-detail-calls/log-detail-calls.service';
import { LogDetailMessagesService } from './log-detail-messages/log-detail-messages.service';
import { LogDetailSsbService } from './log-detail-ssb/log-detail-ssb.service';
import { LogDatasource } from '@features/log/log.datasource';
import { LogSearchParams } from '@features/log/log-search/log-search-params.model';

@Injectable({
  providedIn: 'root',
})
export class LogService {
  datasource = inject(LogDatasource);

  constructor() {
    effect(() => {
      if (this.datasource.isLoaded()) {
        const data = this.datasource.data();
        if (data && data.totalRowCount > 0) {
          this.activeTab.set('result');
        }
      }
    });
  }

  logDetailCallsService = inject(LogDetailCallsService);
  logDetailMessagesService = inject(LogDetailMessagesService);
  logDetailSsbService = inject(LogDetailSsbService);
  selectedLogEntry = signal<LogEntry | undefined>(undefined);
  activeTab = signal('search');

  async searchLog(searchParams: LogSearchParams) {
    this.selectedLogEntry.set(undefined);
    this.datasource.searchParams.set(searchParams);
    this.datasource.loadData();
  }

  selectLogResultRow(logEntry: LogEntry) {
    this.selectLogEntry(logEntry);

    if (logEntry) {
      this.activeTab.set('detail');
    }
  }

  selectLogEntry(logEntry: LogEntry) {
    this.selectedLogEntry.set(logEntry);

    const callsId = logEntry.parentRequestLogId || logEntry.id;
    this.logDetailCallsService.loadCalls(callsId);

    this.logDetailMessagesService.loadMessages(logEntry.id);
    if (logEntry.ssbLogEntryId) {
      this.logDetailSsbService.loadMessages(logEntry.ssbLogEntryId);
    } else {
      this.logDetailSsbService.clear();
    }
  }

}
